import { IStateConfiguration, RequestStatus } from './moduleTypes';

export function createInitialState(configuration: IStateConfiguration) {
  return Object.keys(configuration.modules || {}).reduce((acc, name) => {
    const module = configuration.modules[name];
    return {
      ...acc,
      [name]: {
        status: RequestStatus.IDLE,
        list: [],
        ...(module?.extend?.initialState as object),
      },
    };
  }, {});
}
